// extracted by mini-css-extract-plugin
export default {"app":"Home_app__3FuP-","body":"Home_body__I5zfB","text-area":"Home_text-area__inhhn","fa":"Home_fa__s8W-y","bg_text_area":"Home_bg_text_area__PsTwb","bg":"Home_bg__EKYxH"};